import Modal from 'components/Layout/Modal';
import { Formik } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react';
import Button from 'components/form/Button';
import UploadInput from 'components/form/UploadInput';
import { useDispatch } from 'react-redux';
import { addParticipantsPaymentProof, throwSuccess } from 'store/slices';
import { generatePreSignedUrl, objectToFormData } from 'utils/helpers';
import { paymentAbstractPath } from 'utils/constants';

const PaymentProofUploadPopup = ({ onHide, requestId, handelSuccess, editData, isView }) => {
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);

  useEffect(() => {
    const fetchFileUrl = async () => {
      if (editData?.payment_proof) {
        try {
          const url = await generatePreSignedUrl(editData?.payment_proof, paymentAbstractPath);
          setFileUrl(url);
        } catch (error) {
          console.error("Failed to generate pre-signed URL:", error);
        }
      }
    };

    fetchFileUrl();
  }, [editData]);

  const handleApiSubmit = async (values) => {
    setBtnLoading(true);
    const payload = objectToFormData({
      request_id: requestId,
      payment_proof: values?.payment_proof,
    });

    const response = await dispatch(addParticipantsPaymentProof(payload));
    if (response.status === 200) {
      dispatch(throwSuccess(response?.message));
      onHide();
      handelSuccess();
    }
    setBtnLoading(false);
  };
  const validationSchema = Yup.object().shape({
    payment_proof: Yup.mixed().required('Please upload a payment proof'),
  });

  return (
    <Modal
      titleBesideClose={'Payment Proof'}
      onHide={onHide}
      isTitleBorder
      isTitleVerticalCenter
    >
      {isView ? (
        fileUrl ? (
          <div className="mb-3">
            {/\.(pdf)$/i.test(editData?.payment_proof) ? (
              <iframe
                src={fileUrl}
                width="100%"
                height="500px"
                style={{ border: "none" }}
                title="PDF Preview"
              />
            ) : /\.(jpe?g|png|gif|webp)$/i.test(editData?.payment_proof) ? (
              <img
                src={fileUrl}
                alt="Uploaded file"
                style={{
                  maxWidth: "100%",
                  maxHeight: "500px",
                  borderRadius: "8px",
                  objectFit: "contain",
                }}
              />
            ) : (
              <div>No preview available</div>
            )}
          </div>
        ) : (
          <div>No file uploaded</div>
        )
      )
        :
        (<Formik
          initialValues={{
            payment_proof: null,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleApiSubmit(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            setFieldValue,
            resetForm,
            dirty,
            handleSubmit,
          }) => (
            <form>

              <div className="cps-27 cpe-27 cpt-20 cpb-20">
                <div className="text-14-400-18 color-6866 mb-2">
                  Upload Payment Proof *
                </div>
                <div className="cmb-24">
                  <UploadInput
                    multiple={false}
                    id="payment_proof"
                    value={values.payment_proof}
                    supportedFormats={["PDF", "PNG", "JPG", "JPEG"]}
                    error={touched.payment_proof && errors.payment_proof}
                    handleChange={(e) => {
                      setFieldValue('payment_proof', e?.target?.value);
                    }}
                    isInvoiceFormate
                  />
                  {touched.payment_proof && errors.payment_proof && (
                    <div className="text-danger text-12 mt-1">
                      {errors.payment_proof}
                    </div>
                  )}
                </div>

                <div className="d-flex mt-4 gap-3">
                  <Button
                    btnStyle="primary-dark"
                    text="Save"
                    className="h-37 text-14-500 text-nowrap cps-40 cpe-40"
                    onClick={handleSubmit}
                    btnLoading={btnLoading}
                    disabled={btnLoading || !values?.payment_proof}
                  />

                  <Button
                    btnStyle="light-outline"
                    text="Cancel"
                    className="h-37 text-14-500 text-nowrap cps-40 cpe-40"
                    type="button"
                    disabled={btnLoading}
                    onClick={() => {
                      onHide();
                    }}
                  />
                </div>
              </div>
            </form>
          )}
        </Formik>)}
    </Modal>
  );
};

export default PaymentProofUploadPopup;
